
const UserManagement = require("./src/UserManagement/userManagement").default

module.exports = UserManagement;

